import { User as OidcUser, UserManager, WebStorageStateStore } from 'oidc-client-ts'
import { jumpcloudConfig } from './config'

// oidc-client-ts instead of the Okta SDK: the Okta SDK rejects `aud` as a list (JumpCloud runs
// ORY Hydra) and adds request headers that JumpCloud's CORS rules refuse.

const OIDC_CLIENT_STORAGE_PREFIX = 'oidc.'
const ID_TOKEN_CARRIES_PROFILE_CLAIMS = true
const storageSharedAcrossTabs = window.localStorage

export interface JumpCloudSignInState {
  originalUri: string
}

let jumpcloudUserManager: UserManager | undefined

export function getJumpCloudUserManager(): UserManager {
  if (!jumpcloudUserManager) {
    const jumpcloudStore = new WebStorageStateStore({
      prefix: OIDC_CLIENT_STORAGE_PREFIX,
      store: storageSharedAcrossTabs,
    })
    jumpcloudUserManager = new UserManager({
      authority: jumpcloudConfig.authority,
      client_id: jumpcloudConfig.clientId,
      redirect_uri: jumpcloudConfig.redirectUri,
      response_type: 'code',
      scope: jumpcloudConfig.scope,
      userStore: jumpcloudStore,
      stateStore: jumpcloudStore,
      loadUserInfo: !ID_TOKEN_CARRIES_PROFILE_CLAIMS,
      automaticSilentRenew: true,
    })
  }
  return jumpcloudUserManager
}

function getJumpCloudUserStorageKey(): string {
  return `${OIDC_CLIENT_STORAGE_PREFIX}user:${jumpcloudConfig.authority}:${jumpcloudConfig.clientId}`
}

function getSignInStateStorageKey(signInStateId: string): string {
  return `${OIDC_CLIENT_STORAGE_PREFIX}${signInStateId}`
}

function readStoredJumpCloudUser(): OidcUser | null {
  const storedJumpCloudUser = storageSharedAcrossTabs.getItem(getJumpCloudUserStorageKey())
  return storedJumpCloudUser ? OidcUser.fromStorageString(storedJumpCloudUser) : null
}

export function hasStoredJumpCloudUser(): boolean {
  return storageSharedAcrossTabs.getItem(getJumpCloudUserStorageKey()) !== null
}

export function isJumpCloudSignInCallback(): boolean {
  const signInStateId = new URLSearchParams(window.location.search).get('state')
  if (signInStateId === null) return false

  const hasSavedJumpCloudSignIn =
    storageSharedAcrossTabs.getItem(getSignInStateStorageKey(signInStateId)) !== null
  return hasSavedJumpCloudSignIn
}

export function getJumpCloudIdToken(): string | null {
  const storedJumpCloudUser = readStoredJumpCloudUser()
  if (!storedJumpCloudUser || storedJumpCloudUser.expired) return null
  return storedJumpCloudUser.id_token || null
}

export function clearJumpCloudUser(): void {
  storageSharedAcrossTabs.removeItem(getJumpCloudUserStorageKey())
}
